module.exports = __webpack_public_path__ + "img/01.eb0b4756.png";